import React from 'react';
import { Typography } from "../Typography";
import { Button } from "../Button";
import styles from "./PaginationControl.module.scss";
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
export function PaginationControl(props) {
  const {
    pageSize,
    pageNumber,
    total,
    testid = 'pagination-controls',
    onPageNumberChange
  } = props;
  const start = (pageNumber - 1) * pageSize + 1;
  const end = Math.min(pageNumber * pageSize, total);
  const isPreviousDisabled = pageNumber === 1;
  const isNextDisabled = pageNumber === Math.ceil(total / pageSize);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.root,
    children: [/*#__PURE__*/_jsxs(Typography, {
      skin: "secondary",
      "data-testid": "".concat(testid, "-label"),
      children: ["Viewing ", start, "-", end, " of ", total]
    }), /*#__PURE__*/_jsx(Button, {
      size: "small",
      skin: "primaryOutline",
      disabled: isPreviousDisabled,
      "data-testid": "".concat(testid, "-previous"),
      onClick: () => onPageNumberChange(pageNumber - 1),
      children: "Previous"
    }), /*#__PURE__*/_jsx(Button, {
      size: "small",
      skin: "primaryOutline",
      disabled: isNextDisabled,
      "data-testid": "".concat(testid, "-next"),
      onClick: () => onPageNumberChange(pageNumber + 1),
      children: "Next"
    })]
  });
}